var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"an-export"},[_c('r-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.visible = true}}},[_vm._v(" Экспортировать дэшборд ")]),_c('an-export-modal',{attrs:{"visible":_vm.visible},on:{"close":function($event){_vm.visible = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }